import React, { useContext, useEffect, useRef, useState } from "react";
import { ERROR_MESSAGES } from "../../components/common/GlobalMassssage";
import Select from "react-select";

import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";

import { AddUpdateAdmin, GetAdminModel } from "../../services/Admin/AdminApi";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons

import {
  AddUpdateAdminRole,
  GetAdminRoleModel,
} from "../../services/UserAdminRole/UserAdminRoleApi";
import SuccessModal from "./SuccessModal";

const Profile = ({ isOpen, onClose, setIsAddUpdateDone, modelRequestData }) => {
  const inputRef = useRef(null);
  const ModuleName = "Predefined";
  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  const { validateEmail, handlePhoneNumberInput, stringifyNumber } =
    useContext(AuthContext);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNo: "",
    password: "",
    roleType: null, // Initialize roleType
    adminKeyID: null,
  });
  const [requireErrorMessage, setRequireErrorMessage] = useState(false);
  const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [modelAction, setModelAction] = useState("");
  const { authDetails } = useContext(AuthContext);
  const { setLoader } = useContext(LoaderContext);

  const [isPasswordVisible, setIsPasswordVisible] = useState(false); // State for password visibility

  const roleOptions = [
    { value: "Admin", label: "Super Admin", id: 1 },
    { value: "Manager", label: "Processor", id: 2 },
    { value: "Employee", label: "Reviewer", id: 3 },
  ];

  const handleSelectChange = (selectedOption) => {
    setFormData({ ...formData, roleType: selectedOption });
    setRequireErrorMessage(false);
  };

  useEffect(() => {
    if (isOpen) {
      inputRef.current?.focus();
    }
  }, [isOpen]);

  // Get Model
  useEffect(() => {
    GetClientIndustryModelData(authDetails.adminKeyID);
  }, [authDetails.adminKeyID]);

  if (!isOpen) return null;

  // Get Model Data
  const GetClientIndustryModelData = async (KeyID) => {
    setLoader(true);
    const data = await GetAdminModel(KeyID);
    if (data.statusCode === 200) {
      setLoader(false);
      const ModalData = data.responseData.data;
      setFormData({
        firstName: ModalData.firstName,
        lastName: ModalData.lastName,
        email: ModalData.email,
        mobileNo: ModalData.mobileNo,
        password: ModalData.password, // Do not pre-fill password for security reasons
        roleType:
          roleOptions.find((option) => option.id === ModalData.roleTypeID) ||
          null, // Set roleType based on roleTypeID
      });
    } else {
      setLoader(false);
    }
  };

  const handleSubmit = async () => {
    if (
      formData.firstName === undefined ||
      formData.firstName === null ||
      formData.firstName === "" ||
      formData.lastName === undefined ||
      formData.lastName === null ||
      formData.lastName === "" ||
      // formData.email === undefined ||
      // formData.email === null ||
      // formData.email === "" ||
      ((formData.email || "").length > 0 && !validateEmail(formData.email)) ||
      formData.mobileNo === undefined ||
      formData.mobileNo === null ||
      formData.mobileNo === "" ||
      formData.roleType === undefined ||
      formData.roleType === null ||
      formData.roleType === "" ||
      formData.password === undefined ||
      formData.password === null ||
      formData.password === ""
    ) {
      setRequireErrorMessage(true);
      return false;
    }
    setLoader(true);
    try {
      const data = await AddUpdateAdmin({
        adminKeyID: authDetails.adminKeyID,
        adminKeyIDForUpdate: authDetails.adminKeyID,
        firstName: formData.firstName, // Access from formData
        lastName: formData.lastName, // Access from formData
        email: formData.email, // Access from formData
        mobileNo: formData.mobileNo, // Access from formData
        password: formData.password, // Access from formData
        roleTypeID: formData.roleType.id, // Access from formData
        ModuleName: ModuleName,
      });
      if (data?.statusCode === 200) {
        setLoader(false);
        setShowSuccessPopupModal(true);
      } else {
        setLoader(false);
        const errorMessage = data?.response?.data?.errorMessage;
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  return (
    <>
      <div
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
        onClick={onClose}
        aria-hidden={!isOpen}
      >
        <div
          className="bg-white rounded-lg shadow-lg w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl p-6" // Responsive sizes          role="dialog"
          aria-modal="true"
          onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
        >
          {/* Modal Header */}
          <div
            className="bg-[#ECF6FF] px-6 py-4 border-b flex justify-between items-center"
            style={{ margin: "-22px", marginBottom: "2px" }}
          >
            <h2 className="text-16 font-semibold">Update Profile</h2>
            <button
              className="text-gray-500 hover:text-gray-700"
              onClick={onClose}
              aria-label="Close Modal"
            >
              ✕
            </button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
            {/* First Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                First Name<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={(e) => {
                  const value = e.target.value;

                  // Check if the input matches the desired pattern
                  if (/^[A-Za-z][A-Za-z\s]*$/.test(value) || value === "") {
                    if (value.length <= 30) {
                      // Capitalize the first letter and keep the rest of the string
                      const capitalizedValue =
                        value.charAt(0).toUpperCase() + value.slice(1);
                      setFormData({ ...formData, firstName: capitalizedValue });
                    }
                  }
                }}
                className={`mt-1 block w-full border rounded-md shadow-sm px-3 py-2 text-sm border-gray-300`}
                placeholder="Enter First Name"
              />
              {requireErrorMessage && !formData.firstName && (
                <p className="text-red-500 text-xs mt-1">{ERROR_MESSAGES}</p>
              )}
            </div>

            {/* Last Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Last Name<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={(e) => {
                  const value = e.target.value;

                  // Check if the input matches the desired pattern
                  if (/^[A-Za-z][A-Za-z\s]*$/.test(value) || value === "") {
                    if (value.length <= 30) {
                      // Capitalize the first letter and keep the rest of the string
                      const capitalizedValue =
                        value.charAt(0).toUpperCase() + value.slice(1);
                      setFormData({ ...formData, lastName: capitalizedValue });
                    }
                  }
                }}
                className={`mt-1 block w-full border rounded-md shadow-sm px-3 py-2 text-sm border-gray-300`}
                placeholder="Enter Last Name"
              />
              {requireErrorMessage && !formData.lastName && (
                <p className="text-red-500 text-xs mt-1">{ERROR_MESSAGES}</p>
              )}
            </div>

            {/* Role Type */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Role Type<span className="text-red-500">*</span>
              </label>
              <Select
                options={roleOptions}
                value={formData.roleType}
                onChange={handleSelectChange}
                className={`mt-1 border-gray-300`}
                placeholder="Select Role"
              />
              {requireErrorMessage && !formData.roleType && (
                <p className="text-red-500 text-xs mt-1">{ERROR_MESSAGES}</p>
              )}
            </div>

            {/* Email */}
            <div>
              <label className="block text-gray-700 text-12 mb-1">
                Email <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                placeholder="Email"
                maxLength={20}
                className="w-full p-2 border rounded-md text-12 border-gray-300"
                value={formData.email || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    email: e.target.value,
                  })
                }
              />
              {requireErrorMessage && !formData.email && (
                <label className="validation text-red-500 text-xs mt-1">
                  {ERROR_MESSAGES}
                </label>
              )}
              {formData.email && !validateEmail(formData.email) && (
                <label className="validation text-red-500 text-xs mt-1">
                  Invalid email format
                </label>
              )}
            </div>

            {/* Phone Number */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Phone Number<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                className="flex-grow p-2 border rounded-md border-gray-300 focus:outline-none w-full text-sm" // Added text-sm class
                placeholder="Enter phone number"
                value={formData.mobileNo || ""}
                onChange={(e) => {
                  const validPhoneNumber = handlePhoneNumberInput(
                    e.target.value
                  );
                  setFormData({
                    ...formData,
                    mobileNo: validPhoneNumber,
                  });
                }}
              />
              {requireErrorMessage && !formData.mobileNo && (
                <label className="validation text-red-500 text-xs mt-1">
                  {ERROR_MESSAGES}
                </label>
              )}
              {formData.mobileNo && formData.mobileNo.length < 10 && (
                <label className="validation text-red-500 text-xs mt-1">
                  Invalid Number
                </label>
              )}
            </div>

            {/* Password */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Password<span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({ ...formData, password: e.target.value })
                  }
                  className={`mt-1 block w-full border rounded-md shadow-sm px-3 py-2 text-sm border-gray-300`}
                  placeholder="Enter Password"
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="absolute inset-y-0 right-0 flex items-center pr-3"
                >
                  {isPasswordVisible ? (
                    <FaEyeSlash className="text-gray-500" />
                  ) : (
                    <FaEye className="text-gray-500" />
                  )}
                </button>
              </div>

              {/* Conditional Error Messages */}
              {requireErrorMessage && !formData.password && (
                <label className="validation text-red-500 text-xs mt-1">
                  {ERROR_MESSAGES}{" "}
                  {/* General error message for empty password */}
                </label>
              )}
              {requireErrorMessage &&
                formData.password &&
                formData.password.length < 8 && (
                  <p className="text-red-500 text-xs mt-1">
                    Password must be at least 8 characters long.
                  </p>
                )}
            </div>
          </div>

          {errorMessage && (
            <div className="text-center mt-2">
              <label className="validation">{errorMessage}</label>
            </div>
          )}

          {/* Buttons */}
          <div className="flex justify-end mt-6">
            <button
              type="button"
              className="mr-3 px-5 py-2 bg-gray-300 rounded-md hover:bg-gray-400 text-sm sm:text-base"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="text-white bg-[#E86B1B] rounded-md px-4 py-2 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </div>
      </div>
      <SuccessModal
        isOpen={showSuccessPopupModal}
        onClose={() => {
          onClose();
          setShowSuccessPopupModal(false);
        }}
        modelAction={"Update"}
        actionMessage={formData.firstName}
      />
    </>
  );
};

export default Profile;
